import { render, staticRenderFns } from "./BidDocInfo.vue?vue&type=template&id=117bcc8c&"
import script from "./BidDocInfo.vue?vue&type=script&lang=js&"
export * from "./BidDocInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports